var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCameraFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "50%",
    y: "50%",
    width: 400,
    height: 159,
    transform: "translate(95)",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.3 15.97"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.15 2.38h-4.88l-.22-1A1.39 1.39 0 0012.68.3H7.93a1.39 1.39 0 00-1.37 1.08l-.22 1H1.15a1 1 0 00-1 1v11.3a1 1 0 001 1h18a1 1 0 001-1V3.38a1 1 0 00-1-1zm-12.81 1a1 1 0 001-.78l.22-1A.42.42 0 018 1.29h4.75a.42.42 0 01.4.31l.22 1a1 1 0 001 .78h4.88v3.43H14a4.39 4.39 0 00-6-1.56 4.45 4.45 0 00-1.56 1.56H1.15V3.42zm3.81 2.23A3.42 3.42 0 116.74 9a3.42 3.42 0 013.41-3.39z",
    fill: "#cfcfcf"
  })));
}

export default SvgCameraFilled;